import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F22.css';

import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame22() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F21_image"></div>)
    } else {
        return (
            <div className="F22_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F22_entryBox">
                    <div className="F22_paragraph">
                        {language === 'english' ?
                            <p className="F22_paragraphEnglish">With your help Saira is now out of her room and she is getting ready for school.</p>
                            :
                            <p className="F22_paragraphUrdu">آپ کی مدد سے اب سائرا اپنے کمرے سے باہر آگئی ہے اور اب سکول جانے کی تیاری کر رہی ہے۔</p>
                        }
                    </div>

                    <div className="F22_timeline">
                        <div className='F22_timelineBar'>
                            <div className='F22_timelineFill'></div>
                            <span className='F22_timelineText'>16/16</span>
                        </div>
                    </div>

                    <div className="F22_nextFrames">
                        <div className="F22_nextFrame1"></div>
                    </div>

                    <div className='F22_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(16)) }} className='F22_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame22;